import { el, setAttr } from '/lib/redom.es.js';

import CSSLoader from '/modules/css-loader/index.js';

import Tooltip from '/components/core/tooltip/index.js';

CSSLoader.load('/components/core/toggle-input/index.css');

class ToggleInput {

  constructor(configuration) {

    this.tooltip = null;

    this.offModeValue = configuration.off || 'No';
    this.onModeValue = configuration.on || 'Yes';
    this.value = configuration.value;
    this.onChange = configuration.onChange;
    this.disabled = configuration.disabled || false;

    this.el = el('.toggle-input', {
      disabled: this.disabled,
      onclick: this.toggle.bind(this)
    });
    this.tooltip = new Tooltip({
      content: '',
      target: this.el
    });

    this.setValue(this.value);

  }

  disable() {

    this.disabled = true;

    setAttr(this.el, {
      disabled: this.disabled
    });

  }

  enable() {

    this.disabled = false;

    setAttr(this.el, {
      disabled: this.disabled
    });

  }

  determineStatus(status) {

    if (this.onModeValue === status) {
      return true;
    }

    return false;

  }

  getValue() {

    return this.value;

  }

  setValue(value) {

    this.value = value;

    this.applyValue();

    this.updateTooltip();

  }

  applyValue() {

    if (this.value === true) {
      this.el.classList.add('on');
    } else {
      this.el.classList.remove('on');
    }

  }

  updateTooltip() {

    let content = this.onModeValue;

    if (this.value === false) {
      content = this.offModeValue;
    }

    this.tooltip.update({
      content
    });

  }

  propogateChange() {

    let value = this.getValue();

    this.onChange(value);

  }

  toggle() {

    if (this.disabled === true) {
      return;
    }

    this.value = this.value === false;

    this.applyValue();
    this.updateTooltip();

    this.propogateChange();

  }

  update(configuration) {

    this.value = this.determineStatus(configuration.value);

    this.applyValue();

    this.updateTooltip();

  }

}

export default ToggleInput;